<template>
  <div class="common-layout">
    <el-container v-if="username">
      <el-header>
        <div class="logo-container">
          <img
            class="logo-image"
            src="../src/assets/logo.png"
            alt="logo"
            @click="goback"
          />
        </div>
        <div v-if="username" class="user-info">
          <span>你好，{{ username }}!</span>
          <el-button type="primary" @click="goback">回到主页</el-button>
          <el-button type="primary" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <div class="notice-bar">
        <el-icon style="margin-left: 10vw"><Bell /></el-icon>
        <span class="notice-text"
          >尊敬的用户您好！目前仅开放上海大学宝山校区的打印配送服务，欢迎各位师生下单体验。谢谢！(每日21点后订单默认次日配送，如需当日加急，请联系人工客服)</span
        >
        <el-button
          type="primary"
          class="contact-btn"
          @click="openCustomerService"
          >联系客服</el-button
        >
      </div>

      <el-container>
        <transition name="slide-fade">
          <el-aside width="200px" v-if="!isLoginPage">
            <el-menu
              active-text-color="#fff"
              background-color="#fff"
              class="el-menu-vertical-demo"
              :default-active="activeIndex"
              text-color="#000"
              router
            >
              <template v-if="username === 'admin'">
                <el-menu-item index="/all-orders">
                  <el-icon><Document /></el-icon>
                  <span>所有订单</span>
                </el-menu-item>
                <el-menu-item index="/Home">
                  <el-icon><Setting /></el-icon>
                  <span>管理员下单</span>
                </el-menu-item>
                <el-menu-item index="/user-manage">
                  <el-icon><UserFilled /></el-icon>
                  <span>用户管理</span>
                </el-menu-item>
                <el-menu-item index="/invoice-manage">
                  <el-icon><Document /></el-icon>
                  <span>发票管理</span>
                </el-menu-item>
              </template>
              <template v-else-if="username === 'xiaoneiguanliyuan'">
                <el-menu-item index="/xiaonei-orders">
                  <el-icon><DocumentChecked /></el-icon>
                  <span>我的订单</span>
                </el-menu-item>
              </template>
              <template v-else>
                <el-menu-item index="/Home">
                  <el-icon><Printer /></el-icon>
                  <span>自助下单</span>
                </el-menu-item>
                <el-menu-item index="/my-orders">
                  <el-icon><DocumentChecked /></el-icon>
                  <span>我的订单</span>
                </el-menu-item>
                <el-menu-item index="/invoice">
                  <el-icon><Document /></el-icon>
                  <span>申请开票</span>
                </el-menu-item>
                <el-menu-item index="/user-center">
                  <el-icon><UserFilled /></el-icon>
                  <span>个人中心</span>
                </el-menu-item>
                <el-menu-item index="/price">
                  <el-icon><Setting /></el-icon>
                  <span>价格及工艺</span>
                </el-menu-item>
              </template>
            </el-menu>

            <div class="delivery-info">
              配送时间说明（暂不支持指定配送时间）<br />
              当天11点前订单当天14：00送<br />
              当天11点之后16：00前的订单17：00送<br />
              当天16：00后的订单次日9：30送<br />
              逢双休日、节假日或加急订单，<br />请联系客服 手机号 19370962532
            </div>
          </el-aside>
        </transition>
        <el-main :style="isLoginPage ? { width: 'calc(100% - 20px)' } : {}">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-main>
      </el-container>
    </el-container>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import {
  Printer,
  Document,
  DocumentChecked,
  Setting,
  UserFilled,
  Bell,
} from "@element-plus/icons-vue";
import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    Printer,
    Document,
    DocumentChecked,
    Setting,
    UserFilled,
    Bell,
  },
  setup() {
    const route = useRoute();
    const activeIndex = computed(() => route.path);
    const username = ref(localStorage.getItem("userName") || "");

    return {
      activeIndex,
      username,
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.path === "/";
    },
    isAdmin() {
      return localStorage.getItem("isAdmin") === "true";
    },
  },
  methods: {
    goback() {
      this.$router.push("/Home");
    },
    logout() {
      localStorage.removeItem("userName");
      localStorage.removeItem("userPhone");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("isAdmin");
      localStorage.removeItem("isXiaoneiUser");
      this.username = null;
      this.$router.push("/");
    },
    updateUsername(newName) {
      localStorage.setItem("userName", newName);
      this.username = newName;
    },
    openCustomerService() {
      window.open(
        "https://work.weixin.qq.com/kfid/kfc29ea8a45a91abc91",
        "_blank"
      );
    },
  },
};
</script>

<style>
.el-button + .el-button {
  margin-left: 0;
}

html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

.common-layout {
  height: 100% !important;
}

.common-layout > .el-container {
  height: 100%;
  margin: 0 !important;
}
</style>

<style scoped>
.el-header {
  background: white;
  color: black;
  display: flex;
  align-items: center;
  font-size: 20px;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  height: 60px;
  transition: all 0.3s ease;
  border: 1px solid black;
  border-radius: 18px;
  margin: 10px 20px;
  position: fixed;
  width: calc(100% - 40px);
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-container p {
  margin: 0;
  font-size: 24px;
  color: black;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.logo-image {
  height: 40px;
  width: auto;
  object-fit: contain;
  vertical-align: middle;
  transition: transform 0.3s ease;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.2));
  cursor: pointer;
}

.el-button {
  background: white;
  border: 1px solid black;
  color: black;
  font-weight: 500;
  padding: 8px 20px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.el-button:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 16px;
  opacity: 0.9;
}

.notice-bar {
  background: white;
  border: 1px solid black;
  color: black;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 80px);
  animation: slideDown 0.5s ease;
  justify-content: center;
}

.notice-bar .el-icon {
  color: #005b9e;
  font-size: 20px;
  animation: bellRing 2s ease-in-out infinite;
}

.notice-text {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 1.5;
  color: #005b9e;
  flex: 1;
}

.contact-btn {
  margin-left: 10px;
  background: #005b9e;
  border: 1px solid #005b9e;
  color: white;
  font-weight: 500;
  padding: 8px 20px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background: #004a80;
  border-color: #004a80;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 91, 158, 0.3);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes bellRing {
  0%,
  100% {
    transform: rotate(0deg);
  }
  10%,
  30% {
    transform: rotate(10deg);
  }
  20%,
  40% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(5deg);
  }
  60% {
    transform: rotate(-5deg);
  }
}

.el-aside {
  background: white;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
  transition: all 0.3s ease;
  border: 1px solid black;
  border-radius: 18px;
  margin: 10px;
  position: fixed;
  height: calc(100vh - 150px);
  top: 130px;
  left: 10px;
  width: 200px;
}

.el-menu {
  border-right: none;
  padding-top: 20px;
  background: white;
}

.el-menu-item {
  margin: 8px 16px;
  border-radius: 8px;
  height: 50px;
  line-height: 50px;
  transition: all 0.3s ease;
  box-shadow: none;
  color: black;
}

.el-menu-item:hover {
  background: #f0f0f0 !important;
  transform: translateX(5px);
}

.el-menu-item.is-active {
  background: #333 !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.el-menu-item .el-icon {
  margin-right: 12px;
  font-size: 18px;
  transition: all 0.3s ease;
  color: black;
}

.el-menu-item:hover .el-icon {
  transform: scale(1.1);
}

.el-menu-item.is-active .el-icon {
  color: white;
}

.el-menu-item span {
  font-size: 15px;
  font-weight: 500;
  opacity: 0.95;
}

.delivery-info {
  padding: 20px 10px;
  position: absolute;
  bottom: 20px;
  font-size: 10px;
  color: dimgray;
  line-height: 1.8;
}

.el-main {
  background: white;
  padding: 25px;
  height: calc(100vh - 150px);
  overflow-y: auto;
  transition: all 0.3s ease;
  position: relative;
  border: 1px solid black;
  border-radius: 18px;
  margin: 10px;
  position: fixed;
  top: 130px;
  right: 10px;
  width: calc(100% - 250px);
}

.el-main::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  pointer-events: none;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
  transition: all 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #111;
}

/* 添加页面过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 响应式布局优化 */
@media screen and (max-width: 768px) {
  .el-aside {
    width: calc(64px - 20px) !important;
  }

  .el-main {
    margin-left: 64px !important;
    padding: 15px;
  }

  .el-menu-item span {
    display: none;
  }

  .el-menu-item .el-icon {
    margin-right: 0;
  }
}

.el-menu-item {
  box-shadow: 0 1px 0 #f0f0f0;
}

.el-menu-item:last-child {
  box-shadow: none;
}

/* 侧边栏滑动动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

/* 路由过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 按钮和图标的悬停动画 */
.el-button,
.el-icon {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 卡片和面板的阴影过渡 */
.el-card,
.el-panel {
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  border: 1px solid black;
  border-radius: 8px;
}

.el-card:hover,
.el-panel:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.qr-container {
  text-align: center;
  padding: 20px;
}

.qr-image {
  width: 100%;
  max-width: 300px;
  border: 2px solid #005b9e;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 91, 158, 0.2);
}
</style>